import { RouteEntry } from "../../shared/routes";
import { CampaignGuide } from "./campaignGuide/CampaignGuide";
import { HelpFaqs } from "./faqs/HelpFaqs";
import { HelpHome } from "./HelpHome";
import { campaignAdminRoles } from "./useIsCampaignAdmin";

export const helpRoutes: Array<RouteEntry> = [
    { path: '/help', exact: true, component: HelpHome, authorize: true, },
    { path: '/help/campaign-guide', exact: true, component: CampaignGuide, authorize: true, requireRole: campaignAdminRoles, },
    { path: '/help/faqs', exact: true, component: HelpFaqs, authorize: true, },
];
